import type { Hotel, HotelPageConfiguration } from '~~/domains/graphql';

export function useHotelPageConfiguration(
  hotel: Ref<Hotel | null | undefined>,
) {
  return computed<HotelPageConfiguration>(() => ({
    hide7Pillars: hotel?.value?.pageConfiguration?.hide7Pillars ?? false,
    hideEntertainments:
      hotel?.value?.pageConfiguration?.hideEntertainments ?? false,
    hideFoodsAndBeverages:
      hotel?.value?.pageConfiguration?.hideFoodsAndBeverages ?? false,
    hideIntroduction:
      hotel?.value?.pageConfiguration?.hideIntroduction ?? false,
    hideKidsAndFamilyActivity:
      hotel?.value?.pageConfiguration?.hideKidsAndFamilyActivity ?? false,
    hideKidsAndFamilyOverview:
      hotel?.value?.pageConfiguration?.hideKidsAndFamilyOverview ?? false,
    hideMeetingAndEvent:
      hotel?.value?.pageConfiguration?.hideMeetingAndEvent ?? false,
    hideOffer: hotel?.value?.pageConfiguration?.hideOffer ?? false,
    hideReview: hotel?.value?.pageConfiguration?.hideReview ?? false,
    hideServices: hotel?.value?.pageConfiguration?.hideServices ?? false,
    hideSpa: hotel?.value?.pageConfiguration?.hideSpa ?? false,
    hideSportsActivities:
      hotel?.value?.pageConfiguration?.hideSportsActivities ?? false,
    hideSportsOverview:
      hotel?.value?.pageConfiguration?.hideSportsOverview ?? false,
  }));
}
